/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Use_2_ValueInputs */

const en_svc_n8n_use_2_value = /** @type {(inputs: Svc_N8n_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form and email enquiries enriched, added to the CRM and announced in the right channel.`)
};

const lv_svc_n8n_use_2_value = /** @type {(inputs: Svc_N8n_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieprasījumi no veidlapām un e-pastiem tiek papildināti un pievienoti CRM, un par tiem tiek paziņots atbilstošajā kanālā.`)
};

/**
* | output |
* | --- |
* | "Form and email enquiries enriched, added to the CRM and announced in the right channel." |
*
* @param {Svc_N8n_Use_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_use_2_value = /** @type {((inputs?: Svc_N8n_Use_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Use_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_use_2_value(inputs)
	return en_svc_n8n_use_2_value(inputs)
});